<form [formGroup]="formGroup">
  <mat-checkbox [(ngModel)]="isChecked"  formControlName="myCheckbox"></mat-checkbox>{{isChecked}}
</form>